/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { UserProfileDTO } from '../model/models';
import { UserProfileUpdateForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface UpdateProfiloCittadinoRequestParams {
    userProfileUpdateForm: UserProfileUpdateForm;
}


export interface ProfiloCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lettura del proprio profilo identita\&#39;.
     * Audience: CITTADINO autenticato. Ritorna 404 se il profilo non e\&#39; stato ancora creato (es. utente legacy pre-change).
     * @endpoint get /api/v1/cittadino/profilo
*/
    getProfiloCittadino(extraHttpRequestParams?: any): Observable<UserProfileDTO>;

    /**
     * Aggiornamento del proprio profilo identita\&#39;.
     * Audience: CITTADINO. Il codice fiscale e\&#39; system-only e non puo\&#39; essere modificato via PUT (422 userprofile_campo_non_editabile). Optimistic lock via campo version.
     * @endpoint put /api/v1/cittadino/profilo
* @param requestParameters
     */
    updateProfiloCittadino(requestParameters: UpdateProfiloCittadinoRequestParams, extraHttpRequestParams?: any): Observable<UserProfileDTO>;

}
